import { sendPaginateEvent } from '../../utils/event-triggers';
import { get } from '../../utils/object-helpers';
import { getTracking } from './util';

const CLS = {
    hide: 'hide'
};
const SEL = {
    menuItem: '.menu-button__item',
    stickySentinel: '.str-header__sticky-sentinel',
    itemGrid: '.str-items-grid',
    ebayuiPagination: '.pagination',
    ipp: '.str-pagination__ipp'
};
export default class {
    onMount() {
        this.observerResize();
    }
    onInput(input) {
        this.tabName = input.tabName;
        this.state = {
            pages: get(input, 'pages', []),
            prevUrl: get(input, 'previousPageIcon.action.URL', ''),
            prevText: get(input, 'previousPageIcon.accessibilityText', ''),
            prevTrack: getTracking(get(input, 'previousPageIcon', {})),
            nextUrl: get(input, 'nextPageIcon.action.URL', ''),
            nextText: get(input, 'nextPageIcon.accessibilityText', ''),
            nextTrack: getTracking(get(input, 'nextPageIcon', {})),
            currText: get(input, 'paginationHeader.text', ''),
            ippLabel: get(input, 'itemsPerPage.label.textSpans.0.text', ''),
            ippCurrOptionText: get(input, 'itemsPerPage.currentOption.text', ''),
            ippCurrOptionA11yText: get(input, 'itemsPerPage.currentOption.accessibilityText', ''),
            ippOptions: get(input, 'itemsPerPage.options', [])
        };
        return this.state;
    }
    fetchPage(evt) {
        evt.originalEvent.preventDefault();
        let target = evt.originalEvent.target;
        let href;
        if (target.tagName !== 'A') {
            target = target.closest(SEL.menuItem);
        }
        if (target) {
            href = target.getAttribute('href');
        }
        if (href) {
            this.scrollToTop();
            this.blurLinks();
            sendPaginateEvent({
                url: href,
                tabName: this.tabName,
                successCallback: () => {
                    this.setCurrentPage(href);
                }
            });
        }
    }
    setCurrentPage(href) {
        const pages = get(this.state, 'pages', []);
        for (let i = 0, n = pages.length; i < n; i++) {
            const url = get(pages[i], 'action.URL', '');
            if (url === href) {
                this.state.pages[i].selected = true;
            } else {
                this.state.pages[i].selected = false;
            }
        }
        this.setStateDirty('pages');
    }
    scrollToTop() {
        const stickySentinel = document.querySelector(SEL.stickySentinel);
        if (stickySentinel) {
            const pad = 4;
            const top = stickySentinel.offsetParent.offsetTop + stickySentinel.offsetTop + pad;
            window.scrollTo({
                top,
                left: 0
            });
        }
    }
    blurLinks() {
        const root = this.getEl('str-pagination');
        if (root) {
            const links = root.querySelectorAll('A');
            if (links) {
                links.forEach(el => el.blur());
            }
        }
    }
    // Prevent pagination from overlapping the items-per-page control
    // when the itemGrid resizes due to leftNav opening/closing.
    observerResize() {
        if (ResizeObserver) {
            const pad = 10;
            const itemGrid = document.querySelector(SEL.itemGrid);
            const resizeObserver = new ResizeObserver(this.throttle(() => {
                const root = this.getEl('str-pagination');
                if (root) {
                    const ebayuiPagination = root.querySelector(SEL.ebayuiPagination);
                    const ipp = root.querySelector(SEL.ipp);
                    if (ebayuiPagination && ipp) {
                        const pgRight = ebayuiPagination.offsetLeft + ebayuiPagination.offsetWidth;
                        const ippLeft = ipp.offsetLeft;
                        if ((pgRight + pad) > ippLeft) {
                            ipp.classList.add(CLS.hide);
                        } else {
                            ipp.classList.remove(CLS.hide);
                        }
                    }
                }
            }, 100));

            if (itemGrid) {
                resizeObserver.observe(itemGrid);
            }
        }
    }
    throttle(f, delay) {
        let timer = 0;
        return function(...args) {
            clearTimeout(timer);
            timer = setTimeout(() => f.apply(this, args), delay);
        };
    }
}
